export const theme = {
  colors: {
    primary: '#171D37',
    secondary: '#ff5100',
    surface: '#EBEAFC',
    bg: '#f9fafb',
    subtle: '#DDE1EA',
    text: '#111827',
    muted: '#6b7280',
    placeholder: '#9ca3af',
    border: '#e5e7eb',
    hover: '#f3f4f6',
    danger: '#dc2626',
    status: {
      Sent: {bg: '#FFF2CC', color: '#FFBD00'},
      Viewed: {bg: '#D8FFF8', color: '#009075'},
      Completed: {bg: '#E8F5E9', color: '#2E7D32'},
      Draft: {bg: '#F4F6FB', color: '#0327A9'},
      Declined: {bg: '#FFE1F4', color: '#AB268E'},
      Expired: {bg: '#FFF5F8', color: '#EF5900'},
    },
  },
  radius: {sm: '4px', md: '6px', lg: '8px', full: '9999px'},
  font: {family: "'Inter', sans-serif"},
  shadow: {
    popout: '0 6px 20px rgba(0,0,0,0.14)',
    collapse: '0 4px 14px rgba(0,0,0,0.12)',
  },
  transition: {fast: '0.15s ease', sidebar: '0.22s ease', label: '0.18s ease'},
}
